/* global document, window */
// Store-local, read-only checkout routes. Product and selling-plan values were
// verified from Johns Island public product JSON on 2026-09-15.
export const clubs = [
  {
    name: 'OG Wine Club',
    sunday: 1,
    price: 60,
    checkout: {
      immediate: {
        handle: 'wine-club-og-johns-island-start-today',
        variantId: '48169304981743',
        sellingPlanId: '8036516079',
      },
      'next-month': {
        handle: 'og-wine-club-johns-island',
        variantId: '48279555637487',
        sellingPlanId: '8353841391',
      },
    },
  },
  {
    name: 'Premium Wine Club',
    sunday: 2,
    price: 120,
    checkout: {
      immediate: {
        handle: 'premium-wine-club-johns-island-start-today',
        variantId: '48169305112815',
        sellingPlanId: '8036548847',
      },
      'next-month': {
        handle: 'premium-wine-club-johns-island',
        variantId: '48299004592367',
        sellingPlanId: '8353644783',
      },
    },
  },
  {
    name: 'Club Chill',
    sunday: 3,
    price: 80,
    checkout: {
      immediate: {
        handle: 'club-chill-wine-club-start-today',
        variantId: '48277395669231',
        sellingPlanId: '8036581615',
      },
      'next-month': {
        handle: 'club-chill-johns-island',
        variantId: '48169305145583',
        sellingPlanId: '8353448175',
      },
    },
  },
  {
    name: 'Novel Pairings',
    sunday: 4,
    price: 65,
    checkout: {
      immediate: {
        // The existing storefront handle intentionally retains its current spelling.
        handle: 'novel-parings',
        variantId: '48234525032687',
        sellingPlanId: '8353480943',
      },
      'next-month': {
        handle: 'novel-pairings-start-today',
        variantId: '48278120038639',
        sellingPlanId: '8036614383',
      },
    },
  },
];

export function clubCheckoutUrl(route) {
  if (
    !route ||
    !/^[a-z0-9][a-z0-9-]*$/.test(route.handle) ||
    !/^\d+$/.test(route.variantId) ||
    !/^\d+$/.test(route.sellingPlanId)
  ) {
    throw new Error('Choose an available club start option');
  }
  return `/products/${route.handle}?variant=${route.variantId}&selling_plan=${route.sellingPlanId}`;
}

export function clubCheckoutUrlForChoice(club, choice) {
  return choice?.available ? clubCheckoutUrl(club?.checkout?.[choice.mode]) : null;
}

const iso = (date) => date.toISOString().slice(0, 10);

export function firstPickup(joinDate, sunday) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(joinDate) || ![1, 2, 3, 4].includes(sunday)) {
    throw new Error('Choose a valid date and club');
  }
  const join = new Date(`${joinDate}T12:00:00Z`);
  if (!Number.isFinite(join.getTime()) || iso(join) !== joinDate) throw new Error('Choose a valid date');
  const pickup = (month) => {
    const first = new Date(Date.UTC(join.getUTCFullYear(), month, 1, 12));
    first.setUTCDate(1 + ((7 - first.getUTCDay()) % 7) + (sunday - 1) * 7);
    return first;
  };
  let date = pickup(join.getUTCMonth());
  if (joinDate === iso(date)) return { status: 'same-day', date: iso(date) };
  const nextMonth = join > date;
  if (nextMonth) date = pickup(join.getUTCMonth() + 1);
  return { status: nextMonth ? 'next-month' : 'this-month', date: iso(date) };
}

export function startChoices(today, sunday) {
  const current = firstPickup(today, sunday);
  const next = new Date(`${today}T12:00:00Z`);
  next.setUTCMonth(next.getUTCMonth() + 1, 1);
  return [
    { mode: 'immediate', date: current.date, available: current.status === 'this-month' },
    { mode: 'next-month', date: firstPickup(iso(next), sunday).date, available: true },
  ];
}

if (typeof document !== 'undefined') {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const part = (type) => parts.find((item) => item.type === type).value;
  const today = `${part('year')}-${part('month')}-${part('day')}`;
  const format = (date) =>
    new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(
      new Date(`${date}T12:00:00Z`)
    );

  for (const [index, club] of clubs.entries()) {
    const select = document.querySelector(`#club-start-${index}`);
    const button = document.querySelector(`#club-join-${index}`);
    if (!select || !button) continue;
    const choices = startChoices(today, club.sunday);
    const status = firstPickup(today, club.sunday).status;
    for (const [choiceIndex, choice] of choices.entries()) {
      const option = document.createElement('option');
      option.value = choice.mode;
      option.disabled = !choice.available;
      option.textContent =
        choiceIndex === 0 && !choice.available
          ? status === 'same-day'
            ? 'Start today — confirm pickup with the team'
            : 'Start today — unavailable after pickup'
          : `${choiceIndex === 0 ? 'Start today' : 'Start next month'} — pickup ${format(choice.date)}`;
      select.append(option);
    }
    select.value = choices[0].available ? 'immediate' : 'next-month';
    const update = () => {
      const choice = choices.find((item) => item.mode === select.value && item.available);
      if (!choice) return;
      document.querySelector(`#club-pickup-${index}`).textContent = `First pickup: ${format(choice.date)}.`;
      document.querySelector(`#club-billing-${index}`).textContent =
        choice.mode === 'immediate'
          ? 'Membership starts today. Your next recurring charge is on the 3rd.'
          : '$0 today. Your first monthly payment is scheduled for the 3rd of next month.';
      button.textContent = `Continue to ${club.name} — ${choice.mode === 'immediate' ? 'start today' : 'start next month'}`;
      button.dataset.checkoutUrl = clubCheckoutUrlForChoice(club, choice);
      button.disabled = false;
    };
    select.addEventListener('change', update);
    button.addEventListener('click', () => {
      if (button.dataset.checkoutUrl) window.location.assign(button.dataset.checkoutUrl);
    });
    update();
  }
}
